/*----------------------------------
  トップページ/JavaScript
------------------------------------*/
/*----------------------------------
  jQuery
------------------------------------*/
jQuery(function ($) {
  /*----------------------------------
  トップページ・スクロールによる共通ヘッダーのフェードイン
  ------------------------------------*/
  $(window).scroll(function () {
    if (window.matchMedia("(min-width: 768px)").matches) {
      const scrollAmount = $(window).scrollTop();
      const targetPositionTop = $(".js-top-page__mv").offset().top;
      const targetHeight = $(".js-top-page__mv").height();
      if (scrollAmount > targetPositionTop + targetHeight) {
        $(".js-header").fadeIn();
      } else {
        $(".js-header").fadeOut();
      }
    }
  });
  $(window).on("load resize", function () {
    $(window).trigger("scroll");
    if (window.matchMedia("(max-width: 768px)").matches) {
      $(".js-header").show();
    }
  });

  /*----------------------------------
    トップページ・メインビジュアルのアニメーション
  ------------------------------------*/
  $(".js-top-page__mv-link").hover(
    function () {
      $(this)
        .children(".js-top-page__mv-link-pin")
        .addClass("top-page__mv-link-pin-fadeOut")
        .removeClass("top-page__mv-link-pin-fadeIn");
      $(this)
        .children(".js-top-page__mv-link-balloon")
        .addClass("top-page__mv-link-balloon-fadeIn")
        .removeClass("top-page__mv-link-balloon-fadeOut");
    },
    function () {
      $(this)
        .children(".js-top-page__mv-link-pin")
        .addClass("top-page__mv-link-pin-fadeIn")
        .removeClass("top-page__mv-link-pin-fadeOut");
      $(this)
        .children(".js-top-page__mv-link-balloon")
        .addClass("top-page__mv-link-balloon-fadeOut")
        .removeClass("top-page__mv-link-balloon-fadeIn");
    }
  );

  /*----------------------------------
    トップページ・「学校事業」のアニメーション
  ------------------------------------*/
  $(".js-school-business__list-item01").hover(
    function () {
      $(".js-school-business__pattern03-parts01").addClass(
        "school-business__pattern--visible"
      );
      $(".js-school-business__pattern03-parts02").addClass(
        "school-business__pattern--visible"
      );
    },
    function () {
      $(".js-school-business__pattern03-parts01").removeClass(
        "school-business__pattern--visible"
      );
      $(".js-school-business__pattern03-parts02").removeClass(
        "school-business__pattern--visible"
      );
    }
  );

  $(".js-school-business__list-item02").hover(
    function () {
      $(".js-school-business__pattern04-parts01").addClass(
        "school-business__pattern--visible"
      );
      $(".js-school-business__pattern04-parts02").addClass(
        "school-business__pattern--visible"
      );
    },
    function () {
      $(".js-school-business__pattern04-parts01").removeClass(
        "school-business__pattern--visible"
      );
      $(".js-school-business__pattern04-parts02").removeClass(
        "school-business__pattern--visible"
      );
    }
  );

  $(".js-school-business__list-item03").hover(
    function () {
      $(".js-school-business__pattern05-parts01").addClass(
        "school-business__pattern--visible"
      );
      $(".js-school-business__pattern05-parts02").addClass(
        "school-business__pattern--visible"
      );
    },
    function () {
      $(".js-school-business__pattern05-parts01").removeClass(
        "school-business__pattern--visible"
      );
      $(".js-school-business__pattern05-parts02").removeClass(
        "school-business__pattern--visible"
      );
    }
  );
});
